import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {FormFieldType, SubFormField} from 'hateoas-navigator';

@Component({
  selector: 'app-form-field',
  template: `<div [ngSwitch]="field.getType()">
  <app-input-field *ngSwitchCase="'TEXT'" [control]="control" [field]="field"></app-input-field>
  <app-input-field *ngSwitchCase="'NUMBER'" [control]="control" [field]="field" type="number"></app-input-field>
  <app-input-field *ngSwitchCase="'INTEGER'" [control]="control" [field]="field" type="number"></app-input-field>

  <app-date-time-field *ngSwitchCase="'DATE_PICKER'" [control]="control" [field]="field"></app-date-time-field>
  <app-select-field *ngSwitchCase="'SELECT'" [control]="control" [field]="field"></app-select-field>
  <app-association-field *ngSwitchCase="'LINK'" [control]="control" [field]="field"></app-association-field>

  <app-form-list *ngSwitchCase="'ARRAY'" [formArray]="control" [field]="field"></app-form-list>
  <div *ngSwitchCase="'SUB_FORM'" class="cmp-container">
    <h2 class="mat-h2">{{field.getTitle()}}</h2>
    <app-form-group [formGroup]="control" [fields]="field.getSubFields()"></app-form-group>
  </div>

  <div *ngSwitchDefault>{{field.getType()}} is an unknown type. Therefore {{field.getName()}} cannot be edited.</div>
</div>

<mat-error *ngIf="showRequiredError()">
  {{field.getTitle()}} is <strong>required</strong>
</mat-error>
<mat-error *ngIf="showPatternError() && isNumber()">
  {{field.getTitle()}} only allows <strong>numbers</strong>
</mat-error>
<mat-error *ngIf="showPatternError() && isInteger()">
  {{field.getTitle()}} only allows <strong>integers</strong>
</mat-error>
`,
  encapsulation: ViewEncapsulation.None
})
export class FormFieldComponent implements OnInit {
  @Input()
  field: SubFormField;

  @Input()
  control: AbstractControl;

  ngOnInit(): void {
    if (!this.field) {
      throw new Error(`The control ${JSON.stringify(this.control)} has no form field definition`);
    }
    if (!this.control) {
      throw new Error(`The form field ${JSON.stringify(this.field)} has no control object`);
    }
  }

  showRequiredError(): boolean {
    return this.showError('required');
  }

  showPatternError() {
    return this.showError('pattern');
  }

  isNumber(): boolean {
    return this.field.getType() === FormFieldType.NUMBER;
  }

  isInteger(): boolean {
    return this.field.getType() === FormFieldType.INTEGER;
  }

  private showError(errorCode: string) {
    return this.control.touched && this.control.hasError(errorCode);
  }
}
